import Select from 'components/Common/Form/Input/Select'
import React from 'react'

export function parseTailorMadeTourPreferredCallbackTimeValue(value: string): App.Tours.TailorMadeTourRequest['preferredCallbackTime'] {
  const [from, to] = value.split('-')
  return { from, to }
}

function parseDefaultValue(defaultValue?: App.Tours.TailorMadeTourRequest['preferredCallbackTime']): string | undefined {
  if (!defaultValue) return
  return `${defaultValue.from}-${defaultValue.to}`
}

interface Props {
  name: string
  defaultValue?: App.Tours.TailorMadeTourRequest['preferredCallbackTime']
}

function TailorMadeTourPreferredCallbackTimeInput({ name, defaultValue }: Props) {
  return <Select
    name={name}
    defaultValue={parseDefaultValue(defaultValue)}
    label="Preferred callback time"
    placeholder="eg: 8:00am - 9:00am"
    required
  >
    <option disabled>Morning</option>
    <option value="08:00am-09:00am">8:00am - 9:00am</option>
    <option value="09:00am-10:00am">9:00am - 10:00am</option>
    <option value="10:00ma-11:00am">10:00am - 11:00am</option>
    <option value="11:00am-12:00pm">11:00am - 12:00pm</option>
    <option value="12:00pm-1:00pm">12:00pm - 1:00pm</option>
    <option value="1:00pm-2:00pm">1:00pm - 2:00pm</option>
    <option value="2:00pm-3:00pm">2:00pm - 3:00pm</option>
    <option value="3:00pm-4:00pm">3:00pm - 4:00pm</option>
    <option value="4:00pm-5:00pm">4:00pm - 5:00pm</option>
  </Select>
}

export default TailorMadeTourPreferredCallbackTimeInput
